import { render, staticRenderFns } from "./LexemeForm.vue?vue&type=template&id=6fc684d8&"
import script from "./LexemeForm.vue?vue&type=script&lang=ts&"
export * from "./LexemeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports